:host {
  display: block;
}

/* Panning specific styles */
.carousel-wrapper {
  width: calc(100vw - var(--scrollbar-width));
  display: flex;
  overflow-x: auto;
  padding-bottom: 30px;
  -webkit-overflow-scrolling: touch; /* important for iOS */
}

.scroll-snap-type {
  scroll-snap-type: x mandatory; /* Safari */
  scroll-snap-destination: 50% 50%;
  scroll-behavior: smooth;
}

.scroll-snap {
  scroll-snap-align: center; /* older (Firefox/IE) */
  scroll-snap-coordinate: 50% 50%; /* older (Safari) */
  scroll-snap-stop: normal;
}

/* End of: Panning specific styles */

.gradient-overlay {
  position: absolute;
  z-index: 10;
}

.left-gradient-overlay {
  left: 0;
  /* stylelint-disable-next-line max-line-length */
  background: linear-gradient(90deg, rgb(255 255 255 / 100%) 0%, rgb(255 255 255 / 70%) 80%, rgb(255 255 255 / 0%) 100%);
}

.right-gradient-overlay {
  right: 0;
  /* stylelint-disable-next-line max-line-length */
  background: linear-gradient(90deg, rgb(255 255 255 / 0%) 0%, rgb(255 255 255 / 70%) 20%, rgb(255 255 255 / 100%) 100%);
}

button {
  display: none;

  @include agl-ds-screen-size('medium') {
    display: block;
    background-color: transparent;
    cursor: pointer;

    &.left-button {
      position: absolute;
      z-index: 15;
    }

    &.right-button {
      position: absolute;
      z-index: 15;
    }

    &.hide {
      display: none;
    }
  }
}

.pagination-container {
  margin-left: auto;
  margin-right: auto;
  height: $space-04;
  display: flex;
  gap: $space-01;
  justify-content: center;
  align-items: center;

  .pagination-bullet,
  .pagination-bullet-active {
    transition: width 200ms ease-in-out;
    background: var(--colors-tint-primary-01-40);
    border-radius: $space-06;
    width: 8px;
    height: 8px;
    cursor: pointer;
  }

  .pagination-bullet-active {
    transition: width 200ms;
    background: var(--colors-primary-01);
    width: 24px;
    cursor: default;
  }
}
